const RemedialAction = {
  notrepaired: ["Not Repaired", "Schedule repairs"],
  repaired: ["Repaired", "Immediate repairs"],
  slowOrder: ["Temporary Slow Order"],
  trackOOS: ["Track OOS (Out of Service)"],
};

export function remedialActionUtil(value, id) {
  return RemedialAction[id] && RemedialAction[id].includes(value);
}



// WEBPACK FOOTER //
// ./src/config/RemedialActionConfig.js